<template>
    <div class="title">
        將以變更後或留存公司之行動電話進行門號資料驗證是否為本人申辦
    </div>
    <div class="content">
        <div class="text-error text-sm xs:text-base mb-3.5">
            本人已詳閱臺灣網路認證股份有限公司(下稱：臺網公司)提供之相關文件，充分瞭解「MID門號資料核實」之作業內容，並授權本公司委託臺網公司核實申請人行動電話號碼，以及於「MID門號資料核實」之特定目的內蒐集、處理、利用申請人之行動電話號碼及身分證字號。
        </div>
        <TermsFrame
            height="h-[28vh] md:h-[15.5rem]"
            :content="content"
            @isScrollToBottom="scrollToBottom"
        />
    </div>
    <div class="action justify-center relative">
        <SvgIcon
            v-if="isArrowShow"
            icon-name="expand_more"
            class="text-green-500 h-7 w-7 md:h-9 md:w-9 absolute animate-fade -top-5 md:-top-7"
        />
        <button
            class="btn gradient-primary rounded-full"
            :disabled="isSpin || isDisabled"
            @click.stop="submit()"
        >
            <SvgIcon
                v-if="isSpin"
                icon-name="loading"
                class="animate-spin h-6 w-6"
            />
            <span v-else>確定</span>
        </button>
    </div>
</template>

<script>
import { reactive, ref } from 'vue';
import { getMidClause, submitMidVerify } from '@/apis/mid.js';
import TermsFrame from '@/components/template/TermsFrame.vue';
import { toRefs } from '@vueuse/shared';
export default {
    components: {
        TermsFrame,
    },
    emits: ['isPass', 'result'],
    setup(props, { emit }) {
        const content = ref('');
        const state = reactive({
            isSpin: false,
            isArrowShow: true,
            isDisabled: true,
        });

        getMidClause().then(res => {
            if (res.data) content.value = res.data.html;
        });

        const scrollToBottom = (status) => {
            if (status) {
                state.isArrowShow = false;
                state.isDisabled = false;
            }
        };

        const submit = () => {
            state.isSpin = true;
            submitMidVerify().then(res => {
                if (res.data) {
                    const { verifyResult, mobileChange, mobile, insuredVerifyResult, insuredMobileChange, insuredMobile } = res.data;
                    const result = {
                        data: [
                            {
                                id: 'applicant',
                                mobile: mobile,
                                verifyResult: verifyResult,
                                mobileChange: mobileChange,
                            },
                            {
                                id: 'insured',
                                mobile: insuredMobile,
                                verifyResult: insuredVerifyResult,
                                mobileChange: insuredMobileChange,
                            }
                        ],
                        isBothShow: verifyResult === false && insuredVerifyResult === false
                    };
                    emit('result', result);
                    /* null===不需要進行被保人門號核實 */
                    if (res.data.insuredVerifyResult === null) {
                        emit('isPass', verifyResult);
                    } else {
                        emit('isPass', verifyResult && insuredVerifyResult);
                    };
                }
            }).finally(() => {
                state.isSpin = false;
            });
        };

        return {
            ...toRefs(state),
            content,
            scrollToBottom,
            submit
        };
    }
};
</script>

<style lagn="scss" scoped>
.animate-fade {
    animation: fade 1.3s infinite normal;
}
@keyframes fade {
    0% {
        transform: translateY(-25%);
        opacity: 1;
        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    }
    70% {
        transform: translateY(0);
        opacity: 0.1;
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
    100% {
        transform: translateY(5%);
        opacity: 0;
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
}
</style>
